import { useTheme } from "@mui/joy/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * A hook to identify the current view size/breakpoint in Joy UI.
 * 
 * Default Breakpoints:
 * xs: 0px
 * sm: 600px
 * md: 900px
 * lg: 1200px
 * xl: 1536px
 */
export function useResponsive() {
    const theme = useTheme();

    // Exact breakpoint matches
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isSm = useMediaQuery(theme.breakpoints.only("sm"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isXl = useMediaQuery(theme.breakpoints.only("xl"));

    // Semantic helpers
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // < 600px
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600px - 900px
    const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900px - 1200px
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg")); // > 1200px

    return {
        isXs,
        isSm,
        isMd,
        isLg,
        isXl,
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
    };
}
